import { AfterViewInit, Component, inject } from '@angular/core';
import { ChatBotService, EnvironmentService } from '@mwe/services';
import { ButtonComponent } from '../buttons/button/button.component';

@Component({
  selector: 'mwe-chatbot-popup',
  templateUrl: './chatbot.component.html',
  styleUrls: [],
  imports: [ButtonComponent],
})
export class ChatbotComponent implements AfterViewInit {
  isChatbotVisible = true;

  private chatbotService = inject(ChatBotService);
  private environmentService = inject(EnvironmentService);

  ngAfterViewInit(): void {
    this.startChatBot();
  }

  shutdownChatbot() {
    this.getOnlimEl()?.('shutdown');
    this.chatbotService.eventAsSubject().next(false);
  }

  showChatbot() {
    this.isChatbotVisible = true;
    document.getElementById('mwe-chatbot').style.display = 'block';
  }

  hideChatbot() {
    this.isChatbotVisible = false;
    document.getElementById('mwe-chatbot').style.display = 'none';
  }

  private startChatBot() {
    if (!this.chatbotService.hasScriptAlreadyBeenLoaded) {
      const config = this.environmentService.getChatbotConfig();
      const node: any = document.createElement('script');
      node.id = 'chatbot';
      node.innerHTML = `
        window.OnlimIntegratedCwSettings = {
          widgetId: "${config?.widgetId}",
          apiKey: "${config?.apiKey}",
          baseUrl: "https://app.onlim.com",
          lang: "de"
        };
        (function () {
          var ol = window.OnlimIntegratedCw;
          if (typeof ol !== 'function') {
            var o = function() {
              o.a(arguments);
            };
            o.q = [];
            o.a = function(args) {
              o.q.push(args);
            };
            window.OnlimIntegratedCw = o;
            var d = document;
            var s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://app.onlim.com/chat-app/booter-integrated.js";
            var x = d.getElementsByTagName("script")[0];
            x.parentNode.insertBefore(s, x);
          }
        })();   `;
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';

      document.getElementById('onlim-chat-widget-lite-anchor').appendChild(node);
      this.chatbotService.hasScriptAlreadyBeenLoaded = true;
    }

    this.getOnlimEl()?.('boot');
  }

  private getOnlimEl(): any {
    return (window as any).OnlimIntegratedCw;
  }
}
